<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      订单对比
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
        </div>
        <div>
          <el-button type="primary" @click="subdialogDialog = true">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>订单对比
            </p>
          </el-button>

        </div>
      </div>
      <el-table
          :data="orderList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
      >

        <el-table-column label="序号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ (page - 1) * 10 + scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="考生姓名">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.student_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="考试名称">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.exam_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.order_id }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.fee }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.create_time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <div class="table-item">
              <span v-if="scope.row.state === 1 ">已支付</span>
              <span v-if="scope.row.state === -1 ">已退款</span>
              <span v-if="scope.row.state === 0 ">未支付</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="退款时间">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.returnfee_time }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="orderList.length > 0"
          class="page-all"
          background
          @current-change="setPage"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {examOrderList} from "@/api/projectOffice";

export default {
  name: "examOrder",
  data() {
    return {
      orderList: [],
      page: 1,
      total: 0,
      limit: 10,
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 订单对比",
        true
    );
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
    }
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await examOrderList(this.page, this.limit, '', this.$route.query.id)
      this.orderList = _list.data.data
      this.total = _list.data.total
    },
    setPath() {
      this.$router.push({
        path: '/projectOffice/examOrder',
        query: {
          page: this.page,
          student_name: this.student_name,
          id: this.$route.query.id,
        }
      })
    }
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>